import {axiosAuthInstance} from './axiosInstanceAuth';
import {AxiosResponse} from 'axios';
import {APIResponse} from './baseResponse';

export const recaptchaApi = async (captchaToken: string): Promise<boolean> => {
  return axiosAuthInstance
    .post('recaptcha', {captchaToken})
    .then((response: AxiosResponse<APIResponse<boolean>>) => response.data)
    .catch((error) => error);
};
